import React, { useState, useEffect } from 'react';
import { useUserContext } from '@/Context/UserContext';
import UIStrings from '@/Utils/UIStrings';
import DialogCard from './Components/DialogCard';
import DialogHeader from './Components/DialogHeader';
import DialogTemplate from './Components/DialogTemplate';
import DialogCardInterviewBody from './Components/Interview/DialogCardInterviewBody';
import DialogCardInterviewHeader from './Components/Interview/DialogCardInterviewHeader';
import InviteForInterviewActions from './Components/Interview/InviteForInterviewActions';
import { DialogEnum, useActionDialogContext } from './Context/ActionDialogContext';
import InviteIcon from './Components/Interview/InviteIcon';
import { useCompanyContext } from '@/Context/CompanyContext';
import { useAccountSettings } from '@/api/useAccountSettings';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '@/Components/shadcn/dialog';

interface InviteForInterviewDialogProps {
    assessmentName: string;
}

function InviteForInterviewDialog({ assessmentName }: InviteForInterviewDialogProps): React.JSX.Element {
    const { data: accountSettings } = useAccountSettings();
    const { user } = useUserContext();
    const { currentCompanyProfile } = useCompanyContext();
    const { selectedCandidates, isDialogOpen, hideDialog } = useActionDialogContext();
    const [fullName, setFullName] = useState('');

    const closeInviteForInterviewDialog = () => {
        hideDialog(DialogEnum.InviteForInterview);
    };

    useEffect(() => {
        setFullName(selectedCandidates.length > 1 ? UIStrings.ApplicantNameVariable : selectedCandidates[0]?.name);
    }, [selectedCandidates]);

    return (
        <Dialog
            open={isDialogOpen(DialogEnum.InviteForInterview)}
            onOpenChange={(open) => !open && closeInviteForInterviewDialog()}
        >
            <DialogContent className="flex max-w-7xl flex-row gap-0 overflow-hidden p-0">
                <DialogTitle className="sr-only">{UIStrings.InviteForInterview}</DialogTitle>
                <DialogDescription className="sr-only">{UIStrings.InterviewInvitationEmailTemplate}</DialogDescription>

                <div className="flex w-1/2 flex-col gap-5 p-5 pt-0">
                    <DialogHeader title={UIStrings.InviteForInterview} badgeClassName="bg-primary" />
                    <DialogCard
                        dialogTitle={<DialogCardInterviewHeader name={fullName} />}
                        dialogBody={<DialogCardInterviewBody name={fullName} />}
                        icon={<InviteIcon />}
                        dialogCardContainerClassName="h-63"
                    />
                    <InviteForInterviewActions />
                </div>

                <DialogTemplate
                    dialogTitle={UIStrings.InterviewInvitationEmailTemplate}
                    {...accountSettings.inviteEmailTemplate}
                    candidateName={fullName}
                    recruiterName={`${user.firstName} ${user.lastName}`}
                    companyName={currentCompanyProfile.companyName}
                    recruitmentName={assessmentName}
                    closeDialog={closeInviteForInterviewDialog}
                    editEmailTemplate={() => {}}
                    includeRecruiterName
                />
            </DialogContent>
        </Dialog>
    );
}

export default InviteForInterviewDialog;
